module.exports = __webpack_public_path__ + "static/media/beef9.8693c1ea.jpg";